import { t, Trans } from '@lingui/macro'
import { Select as SelectComponent, Text, VStack } from '@xooom/ui'

export const Select = ({
  value,
  onChange,
  options,
  label,
  required,
  placeholder,
  disabled,
  withoutAll,
  noBorder,
}: {
  value?: string | number
  onChange: (event: { target: { value: string | number } }) => void
  options?: { value: string | number; label: string }[]
  label?: string
  required?: boolean
  placeholder?: string
  disabled?: boolean
  withoutAll?: boolean
  noBorder?: boolean
}) => {
  return (
    <VStack
      css={{
        width: '100%',
        gap: '$1',
        position: 'relative',
        ...(noBorder
          ? {
              '&:hover': {
                backgroundColor: '$gray2',
              },
              pr: 1,
            }
          : {}),
      }}
    >
      {label ? (
        <Text
          size="2"
          color="textNeutral"
          css={{
            ...(noBorder
              ? {
                  fontSize: 10,
                  position: 'absolute',
                  zIndex: 1,
                  left: '$3',
                  top: '$2',
                }
              : {}),
          }}
        >
          {label} {required && <span style={{ color: 'red' }}>*</span>}
        </Text>
      ) : null}
      {placeholder && !value ? (
        <Text
          size="3"
          css={{
            position: 'absolute',
            color: '$gray8',
            zIndex: 1,
            left: '$3',
            top: noBorder ? '$5' : '$6',
          }}
        >
          {placeholder}
        </Text>
      ) : null}
      <SelectComponent
        disabled={disabled}
        css={{
          width: '100%',
          ...(noBorder
            ? {
                height: '100%',
                boxShadow: 'none',
                pt: '$5',
                mx: 1,
                '&:hover': { boxShadow: 'none', backgroundColor: '$gray2' },
              }
            : {}),
        }}
        // @ts-ignore
        value={value}
        onValueChange={(val) => {
          onChange({
            target: { value: val },
          })
        }}
      >
        {!withoutAll && (
          <SelectComponent.Item value="all">
            <Trans>{t`All`}</Trans>
          </SelectComponent.Item>
        )}
        {options?.map((option) => (
          <SelectComponent.Item key={option.value} value={option.value}>
            {option.label}
          </SelectComponent.Item>
        ))}
      </SelectComponent>
    </VStack>
  )
}
